var map = {
	"./en-GB/_lib/formatLong/index.js": 870,
	"./en-GB/index.js": 887,
	"./en-US/_lib/formatDistance/index.js": 861,
	"./en-US/_lib/formatLong/index.js": 871,
	"./en-US/_lib/formatRelative/index.js": 862,
	"./en-US/_lib/localize/index.js": 863,
	"./en-US/_lib/match/index.js": 864,
	"./en-US/index.js": 888,
	"./zh-TW/_lib/formatDistance/index.js": 872,
	"./zh-TW/_lib/formatLong/index.js": 873,
	"./zh-TW/_lib/formatRelative/index.js": 874,
	"./zh-TW/_lib/localize/index.js": 875,
	"./zh-TW/_lib/match/index.js": 876,
	"./zh-TW/index.js": 889
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(function(id) {
		return __webpack_require__.t(id, 7);;
	});
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context | date-locale */ 20).then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 842;
module.exports = webpackAsyncContext;